import React from 'react';
import { Grid } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import PageHeader from '../../../components/page-header';
import { FilterPanel } from '../../../components/filter-panel';
import { usePagedList } from '../../../hooks/use-paged-list';
import { useAgreementSearchController } from './context/agreement-search-controller';
import { useAgreementSearchState } from './context/agreement-search-context';
import AgreementAppService from '../../../application/platform/apm/agreement/agreement-app-service';
import { formatCurrency } from '../../../utils/format';
import { formatDate } from '../../../utils/date';
import { FilterInput } from '../../../components/filter-fields';
import { PagedGrid } from '../../../components/paged-grid';
import { DeleteAction, EditAction } from '../../../components/row-actions';
import { AgreementDrawer } from './components/agreement-drawer';

export function AgreementSearchComponent() {
    const ctrl = useAgreementSearchController();
    const { parameters, searchTrigger, drawer } = useAgreementSearchState();
    const list = usePagedList(AgreementAppService.list, parameters, searchTrigger, 'Não foi possível carregar os convênios');

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'ID', width: 80 },
        { field: 'superiorBody', headerName: 'Órgão superior', flex: 1, minWidth: 220 },
        { field: 'subordinateBody', headerName: 'Órgão subordinado', flex: 1, minWidth: 180 },
        { field: 'managementUnit', headerName: 'Unidade gestora', width: 180 },
        {
            field: 'startDate', headerName: 'Vigência', width: 190, sortable: false,
            valueGetter: (params) => [formatDate(params.row.startDate), formatDate(params.row.endDate)].filter(Boolean).join(' a '),
        },
        { field: 'transferAmount', headerName: 'Repasse', width: 140, type: 'number', valueFormatter: (params) => formatCurrency(params.value) },
        { field: 'counterpartAmount', headerName: 'Contrapartida', width: 140, type: 'number', valueFormatter: (params) => formatCurrency(params.value) },
        {
            field: 'actions', headerName: 'Ações', width: 100, sortable: false,
            renderCell: (params) => (
                <React.Fragment>
                    <EditAction onClick={() => ctrl.openDrawer(params.row)} />
                    <DeleteAction onClick={() => ctrl.handleDelete(params.row)} />
                </React.Fragment>
            )
        }
    ];

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title="Convênios e Repasses"
                    subtitle="Convênios firmados e recursos repassados à entidade"
                    breadcrumbs={[{ label: 'Convênios e Repasses' }]}
                />
            </Grid>
            <Grid item xs={12}>
                <FilterPanel onClear={ctrl.handleClearFilters} onSearch={ctrl.handleSearch}>
                    <Grid item xs={12} md={9}>
                        <FilterInput label="Órgão ou unidade gestora" name="input-term" value={parameters.term} onChange={ctrl.handleOnChange} onSearch={ctrl.handleSearch} />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FilterInput label="Ano de início" name="input-year" type="number" value={parameters.year} onChange={ctrl.handleOnChange} onSearch={ctrl.handleSearch} />
                    </Grid>
                </FilterPanel>
            </Grid>
            <Grid item xs={12}>
                <PagedGrid
                    columns={columns}
                    list={list}
                    parameters={parameters}
                    onPaginationChange={ctrl.handlePaginationChange}
                    addLabel="Novo Convênio"
                    onAdd={() => ctrl.openDrawer()}
                />
            </Grid>

            <AgreementDrawer
                open={drawer.open}
                initial={drawer.agreement}
                isSaving={ctrl.isSaving}
                onClose={ctrl.closeDrawer}
                onSave={ctrl.handleSave}
            />
        </React.Fragment>
    );
}
